export type DeleteDepartmentErrorCode = 'PERMISSION_DENIED' | 'UNKNOWN';

export class DeleteDepartmentError extends Error {
    code: DeleteDepartmentErrorCode;

    constructor(code: DeleteDepartmentErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
